import { Box, Col, Link, Text } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { AddressSearchLocation } from 'components/globals';
import NewSellerFlowAddressInput from 'components/shared/NewSellerFlowAddressInput';
import type { ICompareFinalCta } from 'declarations/contentful';

const RenderCompareFinalCta = (entry: ICompareFinalCta) => {
  const { fields } = entry;

  return (
    <Box backgroundColor="$backgroundInversePrimary" py="$50x" $smallerThanMD={{ py: '$32x' }}>
      <Col maxWidth={1120} px="$12x" mx="auto" width="100%" alignItems="center" gap="$20x">
        <Col gap="$8x" alignItems="center">
          <Text
            tag="h2"
            typography="$subheaderLarge"
            color="$contentInversePrimary"
            textAlign="center"
            $smallerThanMD={{ typography: '$subheaderMedium' }}
          >
            {fields.title}
          </Text>
          <Text
            tag="p"
            typography="$bodyLarge"
            textAlign="center"
            maxWidth={480}
            color="$contentInverseSecondary"
            $platform-web={{ lineHeight: '1.6' }}
          >
            {fields.description}
          </Text>
        </Col>

        <Col gap="$10x" alignItems="center" width="100%" maxWidth={480}>
          <Box width="100%">
            <NewSellerFlowAddressInput
              hideLabel
              inputLocation={
                (fields.addressInputLocation || 'cta-standalone') as AddressSearchLocation
              }
              analyticsPrefix={fields.addressInputAnalyticsPrefix || 'compare-final'}
              trackingTaxonomy="new_homepage"
              placeholder={fields.addressInputPlaceholder || 'Enter your home address'}
              channel="DEFAULT"
              size="medium"
            />
          </Box>
          {fields.subtext && (
            <Text
              tag="p"
              typography="$bodySmall"
              color="$contentInverseTertiary"
              textAlign="center"
            >
              {fields.subtext}
            </Text>
          )}
        </Col>

        {fields.linkText && fields.linkUrl && (
          <Link
            href={fields.linkUrl}
            rel="noopener"
            analyticsName="compare-final-cta-link"
            typography="$bodySmall"
            variant="secondaryInverse"
            textDecorationLine="underline"
          >
            {fields.linkText}
          </Link>
        )}
      </Col>
    </Box>
  );
};

const CompareFinalCta: EntryComponent<ICompareFinalCta> = {
  render: RenderCompareFinalCta,
};

export default CompareFinalCta;
